<h1>{{ rubric.title || "rubric" | translation }}</h1>
<h2>{{ "criteria" | translation }}</h2>
<div>
    <div class="criteria-item" *ngFor="let criteria of rubric.criteria">
        <div class="criteria-item-heading">
            <div class="criteria-item-title">{{ "criteria" | translation }}</div>
            <div class="criteria-item-description" [innerHTML]="criteria.description | formatText"></div>
        </div>
        <div class="criteria-long-description" [innerHTML]="criteria.long_description | formatText"></div>
        <table>
            <thead class="rating-heading">
                <tr>
                    <th>{{ "rating_title" | translation }}</th>
                    <th>{{ "rating_score" | translation }}</th>
                    <th class="primary-header" *ngIf="criteria.has_description">{{ "rating_description" | translation }}</th>
                </tr>
            </thead>
            <tbody class="rating-body">
                <tr *ngFor="let rating of criteria.ratings">
                    <td [innerHTML]="rating.title | formatText"></td>
                    <td [innerHTML]="rating.points"></td>
                    <td [innerHTML]="rating.description | formatText" *ngIf="criteria.has_description"></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>